<div class="toggle-area"  [ngStyle]="{'margin-right': closeStatus? '0':'2rem'}">
  <div class="toggle-area-position" [ngStyle]="{'left': closeStatus? '-2rem':'-1rem'}">
    <span class="toggle-button" 
          [ngClass]="{'shrink-effect': closeStatus}"
          cdkDragBoundary=".toggle-area-position"
          cdkDragLockAxis="y"
          (mousedown)="setClickPosition($event)"
          (mouseup)="toggle($event)"
          cdkDrag>
      <i class="fa fa-angle-double-right"
         [ngClass]="{'flip-effect': closeStatus}"></i>
    </span>
  </div>
</div>